import Fade from '../common/fade/Fade';
import Cover from '../common/cover/Cover';
import Modules from '../gui/modules/Modules';
import Menu from './menu/Menu';
import Chapter from './chapter/Chapter';
import Controller from '../controller/Controller';

export default class Story extends Phaser.GameObjects.Container {
    private fade!: Fade;
    private cover!: Cover;
    private menu!: Menu;
    private chapter!: Chapter;

    constructor(scene: Phaser.Scene) {
        let x = scene.cameras.main.centerX;
        let y = scene.cameras.main.centerY;
        super(scene, x, y);
        this.scene.layers.popups.add(this);

        this.setupUtils();
        this.setupListeners();

        // this.show();
        // this.showChapter(1);
    }

    setupUtils() {
        this.fade = new Fade(this.scene, 0, 0);
        this.add(this.fade);

        this.cover = new Cover(this.scene, 0, 0);
        this.add(this.cover);
    }

    setupListeners() {
        this.scene.events.on(Modules.EVENTS.SHOW_STORY, this.show, this);
        this.scene.events.on(Controller.EVENTS.SHOW_CUTSCENE, this.showCutscene, this);
        this.scene.events.on(Modules.EVENTS.HIDE_STORY, this.hide, this)
    }

    async show(forceChapter = false) {
        this.menu = new Menu(this.scene, 0, 0);
        this.add(this.menu);

        this.menu.once('close', this.hide, this);
        this.menu.on('show_chapter', this.showChapter, this);

        await this.fade.show();
        await this.menu.show();

        if (forceChapter) await this.showChapter(1);
    }

    async showChapter(id: number) {
        // this.scene.tweens.timeScale = 10;

        this.bringToTop(this.cover);
        this.cover.show();

        this.scene.game.events.once('STORY_ASSETS_LOADED', async () => {
            this.chapter = new Chapter(this.scene, 0, 0, id, this);
            this.chapter.once('close', this.onChapterClose, this);
            this.add(this.chapter);

            let jobs = [this.menu.moveOut(), this.chapter.movePages(Chapter.DIRECTIONS.LEFT)];
            await Promise.all(jobs);
            // await this.menu.moveOut();
            // this.chapter.showCaptions();

            this.cover.hide();
        });

        this.scene.game.events.emit('LOAD_STORY_ASSETS', id);
    }

    async showCutscene(cutsceneId: number) {
        if (cutsceneId >= 7) return;
        await this.show();
        this.showChapter(cutsceneId);
    }

    async hide() {
        await this.menu.hide();
        await this.fade.hide();
        this.menu.destroy();
        this.cover.hide();
    }

    async onChapterClose() {
        this.cover.show();
        await this.menu.moveIn();
        this.cover.hide();
    }

    destroy() {
        this.scene.events.off(Modules.EVENTS.SHOW_STORY, this.show, this);
        this.scene.events.off(Controller.EVENTS.SHOW_CUTSCENE, this.showCutscene, this);
        super.destroy();
    }
}
